<template>
    <div class="course-detail-header">
        <!-- <pre v-if="header" v-text="header"></pre> -->

        <!--
        <button class="btn btn__secondary" style="position: absolute; top: 0; left: 20px; z-index: 5;"
                @click="debugTrigger()">
            trigger
        </button>
         -->

        <div class="course-detail-header--wrapper">
            <cmp-entry-animation class="course-detail-header--entry-animation"
                    :variant="entryAnimationVariant"
                    :is-triggered="isTriggered">
                <transition name="trs-cdh-fade" slot="presvg">
                    <div v-if="isTriggered" :key="header.slug" class="course-detail-header--bg trs-cdh-fade"></div>
                </transition>
                <transition name="trs-cdh-fade" slot="postsvg">
                    <div v-if="isTriggered" :key="header.slug" class="course-detail-header--content trs-cdh-fade">
                        <div class="grid--container">
                            <div class="grid--row">
                                <div class="grid--col course-detail-header--aside"></div>
                                <div class="grid--col course-detail-header--main">
                                    <div class="course-detail-header--root">
                                        <div class="course-detail-header--inner">
                                            <h1 class="course-detail-header--title trs-cdh-fade--title"
                                                    v-html="header.title">
                                            </h1>
                                            <span class="course-detail-header--subtitle trs-cdh-fade--subtitle"
                                                    v-html="header.subtitle">
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </cmp-entry-animation>
        </div>
    </div>
</template>

<script>
    import { random } from 'lodash';
    import { mapActions } from 'vuex';
    import isMountedMixin from 'vue/mixins/is-mounted';
    import uuidMixin from 'vue/mixins/uuid';


    function variantGenerator() {
        const MIN = 1;
        const MAX = 5;
        const uids = new Set();

        return function variant() {
            if (uids.size >= MAX - MIN + 1) {
                uids.clear();
            }

            let uid = random(MIN, MAX);

            if (uids.has(uid)) {
                return variant();
            }

            uids.add(uid);

            return uid;
        };
    }


    const getVariant = variantGenerator();


    export default {
        mixins: [
            isMountedMixin,
            uuidMixin,
        ],
        props: {
            header: {
                type: Object,
                default() {
                    return {};
                },
            },
        },
        data() {
            return {
                entryAnimationVariant: null,
                isTriggered: false,
            };
        },
        computed: {
            slug() {
                return this.header.slug;
            },
        },
        methods: {
            ...mapActions(['updateTitleSection', 'removeTitleSection']),
            updateNav() {
                this.updateTitleSection({
                    section: {
                        uuid: this.uuid,
                        title: this.header.title,
                    },
                });
            },
            chooseEntryAnimation() {
                this.entryAnimationVariant = getVariant();
            },
        },
        watch: {
            header: {
                handler() {
                    this.updateNav();
                },
                deep: true,
                immediate: true,
            },
            isMounted: {
                handler(val) {
                    if (!val) {
                        return;
                    }

                    this.isTriggered = val;
                },
                immediate: true,
            },
            slug: {
                handler(val) {
                    if (!val) {
                        return;
                    }

                    this.chooseEntryAnimation();
                },
                immediate: true,
            },
        },
        beforeDestroy() {
            this.removeTitleSection({
                section: {
                    uuid: this.uuid,
                },
            });
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?02c512b7